import { useTranslation } from 'react-i18next';
import { DealItem } from '../models/partner';
import DealCard, { DealModifier } from './dealCard';

export interface DealCardsProps {
  items: DealItem[];
  modifier?: DealModifier;
  skeletons?: React.ReactElement[];
  isLoading?: boolean;
}

function DealCards(props: DealCardsProps) {
  const { t } = useTranslation();

  return (
    <div className={`ct_dealCards ${props.modifier ? `_${props.modifier}` : ''}`}>
      <div className="ct_dealCards-inner">
        {!!props.items && !!props.items.length && props.items.map((deal, index) => (
          <div className="ct_dealCards-item" key={index}>
            <DealCard deal={deal} modifier={props.modifier} />
          </div>
        ))}
        {props.isLoading && props.skeletons && props.skeletons.length
          && props.skeletons.map((skeleton, index) => (
            <div className="ct_dealCards-item" key={index}>
              {skeleton}
            </div>
          ))}
        {!props.isLoading && props.items && !props.items.length && (
          <div className="ct_dealCards-noResult">
            {t(' Sorry, we couldn\'t find any deals.', { ns: 'imports' })}
          </div>
        )}
      </div>
    </div>
  );
}

DealCards.defaultProps = { ...{}, items: [] };

export default DealCards;
